import { __read } from "tslib";
import * as u from './urx';
import { stateFlagsSystem } from './stateFlagsSystem';
export var scrollSeekSystem = u.system(function (_a) {
    var _b = __read(_a, 1), scrollVelocity = _b[0].scrollVelocity;
    var isSeeking = u.statefulStream(false);
    var rangeChanged = u.stream();
    var scrollSeekConfiguration = u.statefulStream(false);
    u.connect(u.pipe(scrollVelocity, u.withLatestFrom(scrollSeekConfiguration, isSeeking, rangeChanged), u.filter(function (_a) {
        var _b = __read(_a, 2), _ = _b[0], config = _b[1];
        return !!config;
    }), u.map(function (_a) {
        var _b = __read(_a, 4), speed = _b[0], config = _b[1], isSeeking = _b[2], range = _b[3];
        var _c = config, exit = _c.exit, enter = _c.enter;
        if (isSeeking) {
            if (exit(speed, range)) {
                return false;
            }
        }
        else {
            if (enter(speed, range)) {
                return true;
            }
        }
        return isSeeking;
    }), u.distinctUntilChanged()), isSeeking);
    u.subscribe(u.pipe(u.combineLatest(isSeeking, scrollVelocity, rangeChanged), u.withLatestFrom(scrollSeekConfiguration)), function (_a) {
        var _b = __read(_a, 2), _c = __read(_b[0], 3), isSeeking = _c[0], velocity = _c[1], range = _c[2], config = _b[1];
        return isSeeking && config && config.change && config.change(velocity, range);
    });
    return { isSeeking: isSeeking, scrollSeekConfiguration: scrollSeekConfiguration, scrollVelocity: scrollVelocity, scrollSeekRangeChanged: rangeChanged };
}, u.tup(stateFlagsSystem), { singleton: true });
